<template>
<div class="component" v-if="isActive">

    <div class="modal is-active" v-if="!isLoading">
        <div class="modal-background" @click="closeModal()"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Datei hinzufügen</p>
                <button class="delete" aria-label="close" @click="closeModal()" ></button>
            </header>
            <section class="modal-card-body">

                <input type="file" id="file" ref="file" v-on:change="handleFileUpload" />
                <br />

                <input class="input" type="text" v-model="fileName" placeholder="Dateiname" />

            </section>
            <footer class="modal-card-foot">
                <button class="button is-success" @click="uploadFile()">Speichern</button>
                <button class="button" @click="closeModal()" >Abbrechen</button>
            </footer>
        </div>
    </div>
        <loadingscreen v-if="isLoading" />

</div>
</template>

<script>
export default {
    name: 'newFileModal',
    props: ["isActive", "areaId"],
    mounted: function () {},
    data() {
        return {
            msg: 'Welcome to Your Vue.js App',
            data: [],
            file: null,
            response: "",
            fileName: "",
            isLoading:false,
        }
    },
    methods: {
        closeModal() {
            this.$emit("close")
                      this.file = null;
            this.fileName = "";
        },
        handleFileUpload(event) {
            this.selectedFile = event.target.files[0]
            this.fileName = this.selectedFile.name
        },
        uploadFile() {

            const formData = new FormData()
            if (this.fileName == '') {
                formData.append('fileName', this.selectedFile.name)

            } else {
                formData.append('fileName', this.fileName)

            }
            formData.append('file', this.selectedFile, this.selectedFile.name)
            formData.append('areaId', this.areaId)
this.isLoading = true;
            this.callApi("/file/add", "post", formData).then(function (response) {
                this.response = response
                                this.isLoading = false;

                this.$emit("refresh")

                this.closeModal();
            }.bind(this)).catch(function (error) {
                this.isLoading = false;
            })
        },
    },
    computed: {},
    watch: {
        isActive: function (val) {
            console.log("isActive changed to " + val)
  
        }
    }
}
</script>

<style scoped>

</style>
